import template from 'text!./transactionWizardTitle.html';
import controller from './transactionWizardTitleCtrl';

/**
 * @ngdoc component
 * @name gw-transaction-wizard-title
 *
 * @description  A component to display the title of the wizard.
 *
 */
export default {
    controller: controller,
    template: template,
    bindings: {
        isQuote: '<',
        isPolicyChange: '<',
        isRenewal: '<'
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/components/transactionWizardTitle/index.js
// module id = 1314
// module chunks = 0